var map = {
	"./GettyImages-1229380660_crop.png": 535,
	"./GettyImages-683364764_crop.png": 536,
	"./Hero_Image_Desktop.jpg": 537,
	"./Hero_Image_Desktop_1.jpg": 538,
	"./Hero_Image_Desktop_2.jpg": 539,
	"./Hero_Image_Desktop_3.jpg": 540,
	"./Hero_Image_Desktop_4.jpg": 541,
	"./Hero_Image_Desktop_5.jpg": 542,
	"./Hero_Image_Desktop_6.jpg": 543,
	"./Hero_Image_Desktop_7.jpg": 544,
	"./Hero_Image_Desktop_8.jpg": 545,
	"./Hero_Image_Mobile.jpg": 546,
	"./Hero_Image_Mobile_1.jpg": 547,
	"./Hero_Image_Mobile_2.jpg": 548,
	"./Hero_Image_Mobile_3.jpg": 549,
	"./Hero_Image_Mobile_4.jpg": 550,
	"./Hero_Image_Mobile_5.jpg": 551,
	"./Hero_Image_Mobile_6.jpg": 552,
	"./Hero_Image_Mobile_7.jpg": 553,
	"./Hero_Image_Mobile_8.jpg": 554,
	"./Hero_Image_Tablet.jpg": 555,
	"./Hero_Image_Tablet_1.jpg": 556,
	"./Hero_Image_Tablet_2.jpg": 557,
	"./Hero_Image_Tablet_3.jpg": 558,
	"./Hero_Image_Tablet_4.jpg": 559,
	"./Hero_Image_Tablet_5.jpg": 560,
	"./Hero_Image_Tablet_6.jpg": 561,
	"./Hero_Image_Tablet_7.jpg": 562,
	"./Hero_Image_Tablet_8.jpg": 563,
	"./James-wong.jpg": 564,
	"./Thought-leaders.jpg": 565,
	"./cattle-drones.jpg": 566,
	"./climate-change-food.jpg": 567,
	"./growing-new-farmers.jpg": 568,
	"./how-to-cut-your-foods-climate-emissions.jpg": 569,
	"./how-to-grow-food-in-a-concrete-jungle.jpg": 570,
	"./it-never-rains.jpg": 571,
	"./seed-of-life.jpg": 572,
	"./the-farms-being-run-from-space.jpg": 573,
	"./the-promised-land.jpg": 574,
	"./the_foods_that_reverse_climate_change_desktop.png": 575,
	"./the_foods_that_reverse_climate_change_mobile.jpg": 576,
	"./the_foods_that_reverse_climate_change_tablet.png": 577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 313;